/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "context/AuthContext";

import * as yup from "yup";

import Logo from "assets/img/logo.svg";
import { Link, useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { centeredContent, whiteBox } from "styles";

import { Alert, Button, Checkbox, Label, TextInput } from "flowbite-react";
import { RegisterCredentials } from "models";
import { BiEnvelope, BiError, BiPhone } from "react-icons/bi";

import "./styles.scss";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { maskPhone } from "utils/mask";
import Tippy from "@tippyjs/react";

interface IFormInput extends RegisterCredentials {
  username: string;
  password: string;
  password_confirm: string;
  first_name: string;
  last_name: string;
  code: string;
  phone: string;
  email: string;
  accept: boolean;
}

export function Register() {
  const navigate = useNavigate();

  const [t] = useTranslation();  

  const { register, setValue, handleSubmit } = useForm<IFormInput>();

  const [submitLabel, setSubmitLabel] = useState("Continuar");
  const [errorMessage, setErrorMessage] = useState("");

  const [loading, setLoading] = useState(false);
  const [validUser, setValidUser] = useState(false);
  const { onRegisterUser, onValidateUser } = useContext(AuthContext);

  async function onSubmit(data: IFormInput) {
    try {
      setLoading(true);
      setErrorMessage("");
      if (!validUser) {
        const result: any = await onValidateUser({
          _id: data.username,
          matricula: data.code,
        });
        try {
          if (result) {
            // setValue('email',result.email);
            setValue("first_name", result.name);
          }
        } catch (e) {}
        setValidUser(!!result);
        setLoading(false);
      } else {
        await onRegisterUser(data);
      }
    } catch (error: any) {
      setLoading(false);
      setErrorMessage(error.message);
    }
  }

  function onSubmitError(error: any) {
    Object.keys(error).forEach((key) => {
      const errors = [];
      error[key].message && errors.push(error[key].message);
      setErrorMessage(errors.join(", "));
    });
  }

  useEffect(() => {
    setSubmitLabel(validUser ? "Cadastrar" : "Continuar");
  }, [validUser]);

  return (
    <>
      <Helmet>
        <title>Cadastro - Rankifier</title>
      </Helmet>
      <div
        id="register-wrapper"
        className="min-h-screen flex flex-col md:flex-row 2xl:items-center md:justify-center"
      >
        {/* <div className="m-3 bg-white p-3 rounded-xl md:m-0 md:bg-none md:rounded-none md:flex-1 flex items-center justify-center py-4 md:p-0 md:max-h-screen md:fixed md:top-0 md:left-[23vw] md:bottom-0">
          <img src={Logo} alt="Logo" className="h-24 md:h-[50vh]" />
        </div> */}

        <div className={whiteBox}>
          <h1 className="font-bold text-2xl 2xl:text-4xl text-blue-dark leading-tight">
            Falta pouco <br className="hidden 2xl:block" />
          </h1>

          <form
            className="w-full mt-2 space-y-2"
            onSubmit={handleSubmit(onSubmit, onSubmitError)}
          >
            <p className="py-3">
              Informe seu CPF para realizar o seu cadastro.
            </p>
            <div className="space-y-3">
              <div className="relative">
                <Label htmlFor="username">CPF</Label>
                <TextInput
                  {...register("username", {
                    onChange: (e) =>
                      (e.target.value = e.target.value.replace(/\D+/g, "")),
                  })}
                  id="username"
                  name="username"
                  type="text"
                  autoComplete="false"
                  placeholder="Digite seu CPF"
                  maxLength={14}
                  required
                  onKeyUp={() => {
                    setErrorMessage("");
                  }}
                  disabled={validUser}
                />
              </div>

              {validUser ? (
                <>
                  <div className="flex space-x-1">
                    <div className="relative flex-1">
                      <Label htmlFor="first_name">Nome</Label>
                      <TextInput
                        {...register("first_name")}
                        id="first_name"
                        name="first_name"
                        type="text"
                        autoComplete="false"
                        placeholder="Seu nome"
                        required
                        readOnly
                        disabled
                      />
                    </div>
                  </div>

                  <div>
                    <Label htmlFor="email">E-mail</Label>
                    <TextInput
                      {...register("email")}
                      id="email"
                      name="email"
                      type="email"
                      autoComplete="false"
                      placeholder="Digite seu e-mail"
                      required
                    />
                  </div>

                  <div>
                    <Label htmlFor="phone">Telefone</Label>
                    <TextInput
                      {...register("phone", {
                        onChange: (e) =>
                          (e.target.value = maskPhone(e.target.value)),
                      })}
                      id="phone"
                      name="phone"
                      type="text"
                      autoComplete="false"
                      placeholder="Informe seu telefone"
                      required
                    />
                  </div>

                  {/* {showPassword && ( */}

                  <div>
                    <Label htmlFor="password">
                      Senha
                    </Label>
                    <TextInput
                      {...register("password")}
                      id="password"
                      name="password"
                      type="password"
                      autoComplete="false"
                      placeholder="Digite sua senha"
                      required
                    />
                  </div>

                  <div>
                    <Label htmlFor="password_confirm">
                      Confirmação de Senha
                    </Label>
                    <TextInput
                      {...register("password_confirm")}
                      id="password_confirm"
                      name="password_confirm"
                      type="password"
                      autoComplete="false"
                      placeholder="Digite novamente a senha"
                      required
                    />
                  </div>

                  <div>
                    <Checkbox
                      {...register("accept")}
                      id="accept"
                      name="accept"
                      required
                    />{" "}
                    <Label htmlFor="accept">
                      Eu concordo com a{" "}
                      <a
                        className="text-blue-500"
                        href="#this"
                        target={"_blank"}
                        rel="noopener noreferrer"
                      >
                        política de privacidade
                      </a>
                      .
                    </Label>
                  </div>
                </>
              ) : null}

              {/* )} */}
            </div>

            {!!errorMessage && (
              <Alert icon={BiError} color={"failure"} className="pr-2">
                {errorMessage}
              </Alert>
            )}

            <div className="flex flex-row justify-center items-center space-x-1 pt-2">
              <Button
                type="submit"
                disabled={loading}
                className="w-full bg-blue-light"
              >
                {loading ? "Aguarde..." : submitLabel}
              </Button>
            </div>

            <div className="text-center pt-2 space-y-3">
              <p>Dúvidas sobre o acesso?</p>
              <div className="flex w-full space-x-3 justify-center">
                <button
                  onClick={() => navigate("/contato")}
                  type="button"
                  className="flex w-1/2 rounded border p-2 space-x-2 items-center justify-center"
                >
                  <BiEnvelope size={20} /> <span>Contato</span>
                </button>
              </div>
            </div>

            <div className="pt-3">
              <hr />
            </div>

            <div className="flex items-center justify-center text-xs pt-2 space-x-2">
              <Link to="/login" className="ml-1 text-blue-500">
                Voltar para login
              </Link>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
